import { urlEncodeParams } from "./urlEncodeParams";

export const urlEncodeAllParamsButRefine = params => {
  const { refine, ...rest } = params;

  return {
    ...urlEncodeParams({ ...rest }),
    refine
  };
};
